import { axios, AxiosResponse } from '@/plugins/axios';

import {
	StudentData,
	StudentOption,
	StudentDossier,
	Attachment,
	AttachmentInfo,
	Message,
	UnreadMessages,
	StudentEditable, StudentInfo
} from './types';
import { AddressInfo } from '@/types';

export function createStudent(params: StudentOption): Promise<AxiosResponse<StudentData>> {
	return axios.post('/api/students', params );
}

export function getStudentInfo(): Promise<AxiosResponse<StudentDossier>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/students/me', {
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}

export function getStudentEditable(): Promise<AxiosResponse<StudentEditable>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/students/me/editable', {
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}

export function getWelcomePack(): Promise<AxiosResponse<Blob>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/documents/welcome_pack.pdf', {
		headers: {
			Authorization: 'Bearer ' + token
		},
		responseType: 'blob'
	});
}

export function getStudentCertificate(): Promise<AxiosResponse<Blob>> {
    const token = sessionStorage.getItem('token');
    return axios.get('/api/students/certificate.pdf', {
        headers: {
            Authorization: 'Bearer ' + token
        },
		responseType: 'blob'
    });
}

export function getStudentAttachments(): Promise<AxiosResponse<AttachmentInfo[]>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/students/me/attachments', {
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}

export function postStudentAttachments(attachments: { [key: string]: Attachment}): Promise<AxiosResponse<StudentDossier>> {
	const token = sessionStorage.getItem('token');
	return axios.post('/api/students/attachment', attachments, {
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}

export function getStudentMessages(): Promise<AxiosResponse<Message[]>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/students/me/messages', {
		headers: {
			Authorization: 'Bearer ' + token
		},
		params: {
			page: 1,
			itemsPerPage: 100
		}
	});
}

export function reopenDossier(): Promise<AxiosResponse<StudentDossier>> {
	const token = sessionStorage.getItem('token');
	return axios.post('/api/students/me/reopen_dossier',
	{},
	{
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}

export function patchStudentAddress(id: string | undefined, info: AddressInfo): Promise<AxiosResponse<AddressInfo>> {
	if (!id) {
		return Promise.reject(new Error('No id found'));
	}
	const token = sessionStorage.getItem('token');
	return axios.patch(`/api/students/${id}/address`, info, {
		headers: {
			Authorization: 'Bearer ' + token,
			'Content-Type': 'application/merge-patch+json'
		}
	});
}

export function patchStudent(id: string | undefined, info: StudentInfo): Promise<AxiosResponse<StudentInfo>> {
	if (!id) {
		return Promise.reject(new Error('No id found'));
	}
	const token = sessionStorage.getItem('token');
	return axios.patch(`/api/students/${id}`, info, {
		headers: {
			Authorization: 'Bearer ' + token,
			'Content-Type': 'application/merge-patch+json'
		}
	});
}

export function getStudentUnreadMessages(): Promise<AxiosResponse<UnreadMessages>> {
	const token = sessionStorage.getItem('token');
	return axios.get('/api/students/me/unread_messages', {
		headers: {
			Authorization: 'Bearer ' + token
		}
	});
}
